'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getCellsAttributesIds = undefined;
var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');
var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
var _extends2 = require('babel-runtime/helpers/extends');
var _extends3 = _interopRequireDefault(_extends2);
var _ramda = require('ramda');
var R = _interopRequireWildcard(_ramda);
function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};
    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
      }
    }
    newObj.default = obj;
    return newObj;
  }
}
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var getCellsAttributesIds = exports.getCellsAttributesIds = function getCellsAttributesIds(layoutIds, attributes) {
  return R.reduce(function (acc, attr) {
    if (!attr.series) {
      return acc;
    }
    if (R.isEmpty(attr.relationship || [])) {
      return R.assoc(attr.id, attr.id, acc);
    }
    var indexedHeaderIds = R.indexBy(R.identity, layoutIds.header);
    var indexedSectionsIds = R.indexBy(R.identity, layoutIds.sections);
    var indexedRowsIds = (0, _extends3.default)({}, indexedSectionsIds, R.indexBy(R.identity, layoutIds.rows));
    var _R$partition = R.partition(function (id) {
        return R.has(id, indexedHeaderIds);
      }, attr.relationship),
      _R$partition2 = (0, _slicedToArray3.default)(_R$partition, 2),
      idsInHeader = _R$partition2[0],
      rest = _R$partition2[1];
    if (R.isEmpty(rest)) {
      return acc;
    } else if (!R.isEmpty(idsInHeader)) {
      return R.assoc(attr.id, attr.id, acc);
    } else {
      var idsNotInSections = R.reject(function (id) {
        return R.has(id, indexedSectionsIds);
      }, attr.relationship);
      if (R.isEmpty(idsNotInSections)) {
        return acc;
      }
      var idsNotInRows = R.reject(function (id) {
        return R.has(id, indexedRowsIds);
      }, idsNotInSections);
      if (R.isEmpty(idsNotInRows)) {
        return acc;
      }
    }
    return R.assoc(attr.id, attr.id, acc);
  }, {}, attributes);
};